import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { SteuernApiService } from '../pages/steuern/services/steuern-api.service';

export const steuernGuard: CanActivateFn = () => {
  const router = inject(Router);
  const steuernApi = inject(SteuernApiService);

  if (steuernApi.taxDeclarationId && steuernApi.isStartComplete()) {
    return true;
  }

  return router.createUrlTree(['/steuern']);
};
